export default "__VITE_ASSET__1bc3613f__"